<template lang="pug">
  .p_mv(:style="mvStyleObj")
    .p_mv-inner
      .p_mv-body.c_col-c
        .c_inner
          .p_mv-body-inner
            h1.p_mv-heading
              span.-sub New Office 3D VR tour
              span.-text ALH 360°
              span.-small As Leading Harmonizer
            .p_mv-scrl
              button.p_mv-scrl-inner(@click="clickToTheContent")
                i.p_mv-scrl-bar
                span.p_mv-scrl-btn Scroll down
            .p_mv-copyright(v-get-current-section="{ hash: '#contact' }")
              p.-text &copy; 2018 ALH INC. All rights reserved.
            .p_mv-navi(v-if="!$store.state.isSmartPhone", v-get-current-section="{ hash: '#contact' }")
              ul.p_mv-navi-list
                li.p_mv-navi-item(v-for="(item, index) in naviItems")
                  button.p_navi(@click="scrollToSection(item.url)", v-get-current-section="{ hash: item.url }")
                    i.p_navi-dot
                      span.p_navi-dot-item
                      span.p_navi-dot-ring
</template>

<script>
  import ScrollToPlugin from "gsap/ScrollToPlugin"
  export default {
    name: 'TheMainVisual',
    directives: {
      getCurrentSection: {
        inserted: function (el, binding) {
          let f = function (evt) {
            var hashRun = false
            let value = binding.value
            let id = document.querySelector(value.hash)
            let rect = id.getBoundingClientRect()
            let position = rect.top
            let height = rect.height

            if (!hashRun && position <= window.innerHeight) {
              hashRun = true
              el.classList.add('current')
            }
            if (position <= (height * -1 / 2) || position >= window.innerHeight) {
              el.classList.remove('current')
            }
          }
          window.addEventListener('scroll', f)
        }
      }
    },
    data () {
      return {
        naviItems: Array,
        mvStyleObj: {
          height: ''
        },
      }
    },
    watch: {
      '$store.state.isSmartPhone': function () {
        this.setMvStyleObj()
      }
    },
    mounted () {
      this.setMvStyleObj()
      this.getMvNavi()
    },
    methods: {
      setMvStyleObj () {
        let sp = this.$store.state.isSmartPhone
        let windowH = document.documentElement.clientHeight
        this.mvStyleObj = (sp) ? { height: windowH + 'px' } : { height: '100vh' }
      },
      getMvNavi () {
        let naviItems = this.$store.state.navi.all
        let renderedItem = naviItems.filter((val) => {
          return (val.target === '_self')
        })
        this.naviItems = renderedItem
      },
      clickToTheContent () {
        let height = document.documentElement.clientHeight
        let header = document.querySelector('.l_header').clientHeight
        TweenLite.to(window, .8, {
          scrollTo: { y: height - header + 20, autoKill: false }
        })
      },
      scrollToSection (hash) {
        let el = document.querySelector(hash)
        let header = document.querySelector('.l_header').clientHeight
        let position = el.offsetTop
        TweenLite.to(window, .8, {
          scrollTo: { y: position - header + 20, aotoKill: false }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
.p_mv {
  @include pc {
    min-height: rem(768);
  }
  @include sp {
    min-height: rem(667);
  }
  // height: 100vh;
  width: 100%;
  position: relative;

  &::before {
    @include sp {
      height: 100vh;
      min-height: rem(500);
      background: url("../../../static/img/top/sp/mv_bg.png") center center no-repeat;
      background-size: cover;
    }
    @include pc {
      height: vh(1000,1050);
      background: url("../../../static/img/top/mv_bg.jpg") center center no-repeat fixed;
      background-size: cover;
    }
    content: "";
    width: 100%;
    min-height: rem(1000);
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
  }

  &-inner {

    @include pc {
      height: calc(100vh - 280px);
      min-height: rem(488);
    }
    @include sp {
      height: calc(100vh - 26.66667vw + 45px);
      min-height: rem(892,2);
    }
    width: 100%;
    position: relative;
  }

  &-body {
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    right: 0;
    margin: auto;
    position: absolute;

    &-inner {
      @include pc {
      }
    }
  }

  &-heading {
    // for SP
    @include mq_max ($bp_m - 1) {}
    @include sp {
      width: rem(554,2);
      text-align: center;
    }

    // for PC
    @include pc {
      width: rem(850);
      transform: translateY(-20%);
    }
    @include sp {
      transform: translateY(-5%);
    }
    @include fo_cus();
    margin: 0 auto;
    color: #fff;

    .-sub {
      // for SP
      @include sp {
        margin: 0 0 rem(5);
      }

      // for PC
      @include pc {
        margin: 0 0 rem(30);
      }
      font-size: rem(16);
      display: block;
      letter-spacing: $ltsp2;
    }

    .-text {
      // for SP
      @include sp {
        width: rem(480,2);
        min-width: rem(480,2);
        margin: 0 0 0 auto;
        font-size: rem(200,2);
        line-height: .9;
        text-align: left;
      }

      // for PC
      @include pc {
        font-size: rem(160);
        text-align: center;
        line-height: .8;
      }
      display: block;
      letter-spacing: $ltsp2;
    }

    .-small {
      // for SP
      @include sp {
        font-size: rem(40,2);
        letter-spacing: .16em;
        margin: rem(5) 0 0;
        letter-spacing: $ltsp2;
      }

      // for PC
      @include pc {
        font-size: rem(24);
        text-align: center;
        letter-spacing: $ltsp;
        margin: rem(24) 0 0;
      }
      display: block;
    }
  }

  &-copyright {
    @include pc {
      left: rem(25);  // アウトラインに合わせる場合は削除
    }
    @include sp {
      left: rem(2);  // アウトラインに合わせる場合は削除
    }
    position: fixed;
    top: 50%;
    transform: translateY(-50%);
    z-index: 998;

    &.current .-text {
      color: #fff;
    }

    .-text {
      @include pc {
        font-size: rem(12);
      }
      @include fo_google();
      color: #eee;
      font-weight: bold;
      writing-mode: vertical-rl;
      transition: all .3s ease;
    }
  }

  &-navi {
    position: fixed;
    top: 50%;
    right: rem(30);  // アウトラインに合わせる場合は削除
    transform: translateY(-50%);
    z-index: 999;

    &-list {}

    &-item {
      @include pc {
      }
    }
  }

  &-scrl {
    // for SP
    @include sp {
      bottom: rem(25);
    }

    // for PC
    @include pc {
      bottom: rem(40);
    }
    text-align: center;
    overflow: hidden;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 998;

    &-inner {
      @include pc {
        padding: rem(90) 0 0;
      }
      @include sp {
        padding: rem(48) 0 0;
      }
      line-height: 1;
      margin: 0 auto;
      display: inline-block;
    }

    &-bar {
      @include pc {
        height: rem(80);
      }
      @include sp {
        height: rem(40);
      }
      width: rem(2);
      display: block;
      position: absolute;
      margin: auto;
      left: 0;
      right: 0;
      top: 0;
      overflow: hidden;

      &::after {
        @include pc {
        }
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        background: #fff;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        margin: auto;
        transform: translateY(-100%);
        animation: scrollBtn 2s ease-in-out 0s infinite;
      }
    }

    @keyframes scrollBtn {
      0% {
        transform: translateY(-100%);
      }
      100% {
        transform: translateY(80px);
      }
    }

    &-btn {
      @include sp {
        font-size: rem(14);
      }
      @include fo_cus();
      color: #fff;
      letter-spacing: $ltsp;
    }
  }
}

.p_navi {
  @include pc {
    width: rem(24);
    height: rem(24);
    position: relative;
  }
  opacity: .4;

  &.current {
    opacity: 1;
  }

  &.current &-dot-ring {
    transform: scale(1);
  }

  &-dot {
    @include pc {}
    position: absolute;
    width: 100%;
    height: 100%;

    &-item {
      position: absolute;
      width: cal(6,24);
      height: cal(6,24);
      border-radius: 50%;
      background: #eee;
      display: block;
      margin: auto;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }

    &-ring {
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      border: 1px solid #eee;
      display: block;
      margin: auto;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      transform: scale(0);
      transition: all .3s ease;
    }
  }
}

.p_mv-navi.current .p_navi {
  &-dot {
    &-item {
      background: #fff;
    }

    &-ring {
      border-color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/top/TheMainVisual.vue